import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink, Router } from '@angular/router';
import { DatePipe } from '@angular/common';

// translation service
import { TranslatePipe } from '@ngx-translate/core';

import { ClientService } from '../../services/client-service';
import { NotificationService } from '../../services/notification-service';
import { Client } from '../../models/client';
import { VerticalTabsComponent } from './controls/vertical-tabs/vertical-tabs';

import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';


@Component( {
  selector: 'app-client',
  imports: [
    RouterLink,
    DatePipe,
    MatGridListModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatDividerModule,
    VerticalTabsComponent,
    TranslatePipe
  ],
  templateUrl: './client.html',
  styleUrl: './client.css'
} )
export class ClientComponent implements OnInit
{
 
  private route: ActivatedRoute = inject( ActivatedRoute );
  public clientId = this.route.snapshot.paramMap.get( 'clientId' ) || undefined;
  public client: Client | undefined = undefined;

  constructor(
    private _router: Router,
    private _clientService: ClientService,
    private _notificationService: NotificationService,
  ) { }

  async ngOnInit(): Promise<void>
  {
    if ( !this.clientId)
    {
      this._notificationService.showErrorMessage( 'Client ID is not provided in the route parameters.' );
      return;
    }

    try
    {
      this.client = await this._clientService.getClient( this.clientId );
    }
    catch ( error )
    {
      this._notificationService.showErrorMessage( 'Failed to load client data.' );
      this._router.navigate( ['/main'] );
      return;
    }

    this._clientService.setViewedClient( this.client! );    
  }

}
